import { Stack, Divider } from '@kinesis/bungle';
import { ScenarioOutput } from '@/types';
import { Layout } from '@/components/layout';
import { DownloadLink } from './download-link';
import { BudgetIndicators } from './budget-indicators';
import { AnnualEmissions } from './annual-emissions';
import { EmissionsReductions } from './emissions-reductions';

const ScenarioOutputs = (props: ScenarioOutputsProps) => {
  const { simulation, onDownload } = props;
  return (
    <Layout>
      <Stack space='medium'>
        <Stack space='large'>
          <BudgetIndicators budget={simulation.budget} />
          <AnnualEmissions emissions={simulation.emissions} />
          <EmissionsReductions reductions={simulation.reductions} />
          <Divider />
        </Stack>
        <DownloadLink onDownload={onDownload} />
      </Stack>
    </Layout>
  );
};

export type ScenarioOutputsProps = {
  simulation: ScenarioOutput;
  onDownload?: () => void;
};

export { ScenarioOutputs };
